export enum AdvancedSearchFieldType {
  ALL = 'all',
  ANY = 'any',
  EXACT = 'exact',
  EXCLUDES = 'excludes',
}

export interface AdvancedSearchFields {
  [AdvancedSearchFieldType.ALL]?: string;
  [AdvancedSearchFieldType.ANY]?: string;
  [AdvancedSearchFieldType.EXACT]?: string;
  [AdvancedSearchFieldType.EXCLUDES]?: string;
}
